// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"32427600","85":"32427600","189":"c0f60f38","207":"8b6f7a7f","867":"e0c296a4","869":"98619171"}[chunkId] + ".chunk.css";
};